<div class="space-y-2">
  @if (variant() === 'icon') {
    <div class="flex items-center gap-2">
      @if (attachments().length) {
        <ul class="flex min-w-0 flex-1 flex-wrap gap-2">
          @for (attachment of attachments(); track attachment.key) {
            <li
              class="inline-flex max-w-full items-center gap-1.5 rounded-md border border-gray-200 dark:border-zinc-700 bg-gray-50 dark:bg-zinc-800 px-2 py-1">
              @if (isImage(attachment.fileType)) {
                <img [src]="attachment.url" [alt]="" class="size-5 rounded object-cover" />
              }
              <p class="m-0 truncate text-xs text-primary">{{ attachment.fileName }}</p>
              <button
                type="button"
                class="shrink-0 text-xs text-secondary hover:text-primary"
                (click)="removeAttachment(attachment)">
                <span class="sr-only">Remove {{ attachment.fileName }}</span>
                <span aria-hidden="true">×</span>
              </button>
            </li>
          }
        </ul>
      } @else {
        <div class="min-w-0 flex-1"></div>
      }

      <label class="inline-flex shrink-0">
        <span
          class="inline-flex size-8 cursor-pointer items-center justify-center rounded-md text-secondary hover:bg-gray-100 hover:text-primary dark:hover:bg-zinc-700"
          [class.opacity-50]="uploading() || attachments().length >= maxAttachments"
          [class.pointer-events-none]="uploading() || attachments().length >= maxAttachments"
          [attr.title]="uploading() ? 'Uploading…' : 'Add attachment'">
          @if (uploading()) {
            <span class="sr-only">Uploading</span>
            <svg
              class="size-5 animate-spin"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              aria-hidden="true">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          } @else {
            <span class="sr-only">Add attachment</span>
            <svg
              class="size-5"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              aria-hidden="true">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m.01-.01 3.182-3.182m0 3.182.338.338" />
            </svg>
          }
        </span>
        <input
          type="file"
          class="sr-only"
          [accept]="accept"
          [disabled]="uploading() || attachments().length >= maxAttachments"
          (change)="onFileSelected($event)"
        />
      </label>
    </div>
  } @else {
    <label class="inline-flex items-center gap-2">
      <span class="btn-basic-sm btn-secondary cursor-pointer">
        @if (uploading()) {
          Uploading…
        } @else {
          Add attachment
        }
      </span>
      <input
        type="file"
        class="sr-only"
        [accept]="accept"
        [disabled]="uploading() || attachments().length >= maxAttachments"
        (change)="onFileSelected($event)"
      />
    </label>

    @if (attachments().length) {
      <ul class="space-y-2">
        @for (attachment of attachments(); track attachment.key) {
          <li class="flex items-center justify-between gap-3 rounded-lg border border-gray-200 dark:border-zinc-700 px-3 py-2">
            <div class="min-w-0 flex items-center gap-2">
              @if (isImage(attachment.fileType)) {
                <img [src]="attachment.url" [alt]="attachment.fileName" class="h-10 w-10 rounded object-cover" />
              }
              <p class="m-0 truncate text-sm text-primary">{{ attachment.fileName }}</p>
            </div>
            <button type="button" class="text-sm text-secondary hover:text-primary" (click)="removeAttachment(attachment)">
              Remove
            </button>
          </li>
        }
      </ul>
    }
  }

  @if (error()) {
    <p class="text-sm text-rose-600">{{ error() }}</p>
  }
</div>
